<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";
import {useRoute} from "vue-router";

const route = useRoute()
const dataForm = ref({
  name: '',
  phone: '',
  email: '',
  contents: '',
  client_path: '',
  client_ip: '',
  client_country: ''
})
const statusMessage = ref('');

function get_ip() {
  axios
      .get('https://api.ipify.org?format=json')
      .then(response => {
        dataForm.value.client_ip = response.data.ip
      })
      .catch(error => {
        console.log(error)
      })
}

function get_country() {
  axios
      .get('https://get.geojs.io/v1/ip/geo.json')
      .then(response => {
        dataForm.value.client_country = response.data.country
      })
      .catch(error => {
        console.log(error)
      })
}


function send_email() {
  dataForm.value.client_path = route.path
  axios
      .post('/api/mail', dataForm.value)
      .then(response => {
        statusMessage.value = 'Email sent successfully!';
      })
      .catch(error => {
        statusMessage.value = 'Failed to send email.';
      })
}

onMounted(() => {
  get_ip()
  get_country()
})
</script>

<template>
  <form @submit="send_email" action="" class="lt-form">
    <div class="form-group">
      <input v-model="dataForm.name" type="text" class="form-control" placeholder="Your Name">
      <div class="input-addon">
        <i class="fa fa-user-o" aria-hidden="true"></i>
      </div>
    </div>
    <div class="form-group">
      <input v-model="dataForm.phone" type="text" class="form-control" placeholder="Phone">
      <div class="input-addon">
        <i class="fa fa-phone" aria-hidden="true"></i>
      </div>
    </div>
    <div class="form-group">
      <input v-model="dataForm.email" type="email" class="form-control" placeholder="Email">
      <div class="input-addon">
        <i class="fa fa-envelope-o" aria-hidden="true"></i>
      </div>
    </div>

    <div class="form-group">
      <textarea  v-model="dataForm.contents"  cols="30" rows="10" class="form-control" placeholder="Your Contents"></textarea>
      <div class="input-addon">
        <i class="fa fa-comment-o" aria-hidden="true"></i>
      </div>
    </div>
    <input type="submit" value="Send Message" class="btn btn-primary">
    <p v-if="statusMessage">{{ statusMessage }}</p>
  </form>
</template>

<style scoped lang="scss">

</style>